<p>default privacy works</p>
